// Export the Component Definition for use in Contentful Studio
export {SimpleListContentfulComponentDefinition} from './SimpleListContentfulDefinition';
export {default} from './SimpleList';
